// src/App.tsx

import {
    Routes,
    Route,
} from 'react-router-dom';
import { useEffect } from 'react';

// import ProtectedRoute from './auth/ProtectedRoute';
// import RoleRoute from './auth/RoleRoute';
import RootLayout from './components/layouts/RootLayout';
import { LoginPage } from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import { SuccessPage } from './pages/SuccessPage';
import VerifyRoute from './routes/VeridyRoute';
import { GoogleOAuthProvider } from '@react-oauth/google';
import CommunityLayout from './components/community/layout/CommunityLayout';
import Community from './pages/community/Community';
import { useAuthStore } from './auth/auth.store';

function AuthSessionBootstrap() {
  const fetchCurrentUser = useAuthStore((state) => state.fetchCurrentUser);

  useEffect(() => {
    void fetchCurrentUser();
  }, [fetchCurrentUser]);

  return null;
}


export default function App() {
  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

    return <>
        <AuthSessionBootstrap />
        <Routes>

            <Route element={<RootLayout />}>

                <Route
                            path=""
                            element={<CommunityLayout />}
                        >
                            <Route
                                index
                                element={
                                    <Community />
                                }
                            />
                        </Route>


                {/* Authentication */}

                <Route path="/login" element={<GoogleOAuthProvider clientId={googleClientId || "google-client-id-missing"}><LoginPage /></GoogleOAuthProvider>} />

                <Route path="/register" element={<GoogleOAuthProvider clientId={googleClientId || "google-client-id-missing"}><SignupPage /></GoogleOAuthProvider>} />

                {/* Registration verification */}

                <Route path="/verify" element={<GoogleOAuthProvider clientId={googleClientId || "google-client-id-missing"}><VerifyRoute /></GoogleOAuthProvider>} />


                {/* Registration success */} 
                
                <Route path="/success" element={<SuccessPage />} />


            </Route>

            {/* Public */}


            {/* <Route
                    path="/unauthorized"
                    element={<Unauthorized />}
                /> */}

            {/* Authenticated users */}
            {/* <Route element={<ProtectedRoute />}>

                    
                </Route> */}

            {/* Admins */}
            {/* <Route element={
                        <RoleRoute
                            roles={['admin', 'superadmin']}
                        />
                    }>
                    
                    </Route> */}

        </Routes>
    </>
}
